if (!customElements.get('gma-product-details')) {
  class GmaProductDetails extends HTMLElement {
    connectedCallback() {
      this.rows = Array.from(this.querySelectorAll('details.gma-product-details__row'));
      if (!this.rows.length) return;

      this.applyHash();
      window.addEventListener('hashchange', () => this.applyHash());
    }

    applyHash() {
      const hash = window.location.hash.replace('#', '');
      if (!hash) return;

      const match = this.rows.find((row) => {
        return row.id === hash || row.getAttribute('data-legacy-id') === hash;
      });

      if (!match) return;

      match.open = true;
      match.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  customElements.define('gma-product-details', GmaProductDetails);
}
